import React from 'react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Server from '../../../functions/server';

class DetailStatement extends React.Component {

  state = {
    purchaserDetailStatement: [], maxWidth: 'lg', fullWidth: true, fromDate: this.getFormatedDate(new Date(), 7),
    toDate: this.getFormatedDate(new Date()),
  }

  // Set From And To Date Function
  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x = dates.getFullYear() + "-" + month + "-" + date;
    if (interval == 7) {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    return x;
  }

  componentDidUpdate(props) {
    if (props.fromDate != this.props.fromDate || props.toDate != this.props.toDate) {
      this.setState({ fromDate: this.props.fromDate, toDate: this.props.toDate })
    }
  }

  downloadpdf() {
    let open = Server() + "pdf/purchaserstatement.php?purchaserId="+this.props.id+"&fromDate="+
    this.props.fromDate+"&toDate="+this.props.toDate+'&closingBalance='+Number(this.props.closingBalance).toFixed(2)+
    '&openingbalance='+Number(this.props.openingBalance).toFixed(2);
    window.open(open);
  }

  //  Get Purchaser Detail Statement
  getDetailStatement() {
    let context = this;
    $.ajax({
      type: 'POST', data: { 'id': context.props.id, 'fromDate': context.state.fromDate, 'toDate': context.state.toDate },
      url: Server() + 'purchaserStatement/getPurchaserDetailStatement.php',
      success: function(purchaserDetailStatement) {
        console.log(purchaserDetailStatement);
        try {
          context.setState({ 
            purchaserDetailStatement: JSON.parse(purchaserDetailStatement), 
            load: false, 
            openDetailsStatementDialog: true 
          })
        } catch (error) {
          context.setState({ load: false })
        }
      },
      error: function(err) {
        alert('Try again!!!')
      }
    });
  }

  //Caculate Closing Balance
  calculateClosingBalance() {
    let context = this;
    let purchaserDetailStatement = this.state.purchaserDetailStatement;
    let openingBalance = this.props.openingBalance;
    purchaserDetailStatement.map((c) => {
      let amount = this.ConvertIntoNumber(c.amount);
      openingBalance = (openingBalance) + (amount);
    })
    return openingBalance;
  }

  // Convert Into Number
  ConvertIntoNumber = (value) => {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  // Make Decimal Point
  makeDecimalPoint = (value) => {
    try {
      value = value.toFixed(2);
    } catch (value) {
      value = 0;
    }
    return value;
  }


  closingBalanceForEarchColumnCalculation(purchaserDetailStatement) {
    let openingBalance = this.props.openingBalance;
    let length = purchaserDetailStatement.length;
    for (var i = length; i > 0; --i) {
      let amount = purchaserDetailStatement[i - 1].amount;
      amount = this.ConvertIntoNumber(amount);
      openingBalance = ((openingBalance) + (amount));
      purchaserDetailStatement[i - 1].closing = openingBalance;
    }
    return purchaserDetailStatement;
  }

  sorting(data) {
    data.sort(function(a,b){
      return new Date(b.timestamp) - new Date(a.timestamp);
    });
    return data;
  }

  // Data And Test Box Handle Function
  handleChange = name => event => { this.setState({ [name]: event.target.value }); };
  
  render() {
    let closingBalance = this.calculateClosingBalance();
    let openingBalance = this.props.openingBalance;
    let closingBalanceForEarchColumnCalculation = this.sorting(this.state.purchaserDetailStatement);
    closingBalanceForEarchColumnCalculation = this.closingBalanceForEarchColumnCalculation(closingBalanceForEarchColumnCalculation);
    return (
      <div>
        <div onClick={this.getDetailStatement.bind(this)}>View</div>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}  open={this.state.openDetailsStatementDialog}
          onClose={ () => { this.setState({ openDetailsStatementDialog: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Detailed Statement</DialogTitle>
          <DialogContent>
            <div style={{textAlign: 'right', fontSize: '18px', color: 'blue'}}>{'Closing balance :'+this.makeDecimalPoint(closingBalance)}</div>
              
              <table id="table" width="100%" style={{marginTop: '2px'}}>
                <tr>
                  <th id="tableheader"><center>Voucher</center></th>
                  <th id="tableheader"><center>Type</center></th>
                  <th id="tableheader"><center>Date</center></th>
                  <th id="tableheader"><center>Inwards</center></th>
                  <th id="tableheader"><center>Outwards</center></th>
                  <th id="tableheader"><center>Mode</center></th>
                  <th id="tableheader"><center>Closing Balance</center></th>
                </tr>
                { 
                  closingBalanceForEarchColumnCalculation.map((c) => {
                    let amount = this.ConvertIntoNumber(c.amount);
                    let InwardsAmount = this.ConvertIntoNumber(c.amount);
                    let OutwardsAmount = this.ConvertIntoNumber(c.amount);
                    if (c.type == 'Purchase') {
                      OutwardsAmount = '';
                      InwardsAmount = InwardsAmount * -1;
                    }
                    if (c.type == 'Payment') {
                      InwardsAmount = '';
                    }
                    if (c.type == 'Receipt') {
                      OutwardsAmount = '';
                      InwardsAmount = InwardsAmount * -1;
                    }
                    openingBalance = (openingBalance) + (amount);
                    return (
                      <tr>
                        <td>{c.payment_voucher}</td>
                        <td>{c.type}</td>
                        <td>{c.timestamp}</td>
                        <td><div>{this.makeDecimalPoint(InwardsAmount)}</div></td>
                        <td><div>{this.makeDecimalPoint(OutwardsAmount)}</div></td>
                        <td><div>{c.mode}</div></td>
                        <td><div style={{textAlign: 'right'}}>{this.makeDecimalPoint(c.closing)}</div></td>
                      </tr>
                    )
                  })
                }
              </table>
              <div style={{textAlign: 'right', fontSize: '18px', color: 'blue'}}>{'Opening balance :'+this.makeDecimalPoint(this.props.openingBalance)}</div>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ openDetailsStatementDialog: false }) }}>Close</Button>
            <Button onClick={this.downloadpdf.bind(this)}>Download PDF</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default DetailStatement;
